const SCALING_MAP = {
    height: 720,
    width: 1280,
};

const getDynamicScalingMap = (scalingFactor) => {
    if (scalingFactor === 'height') {
        return {
            height: 1280,
            width: 720,
        };
    }

    return SCALING_MAP;
};

export default {
    getDynamicScalingMap,
};
